import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Auth0Service } from '../auth0/auth0.service';
/**
* This guard is used to check whether the user has access to a particular route.
*
* If a user doesn't have access to the route then it redirects the user to the login screen.
*/
@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private router: Router,
    private auth0Service: Auth0Service
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth0Service.isAuthenticated()) {
      return true;
    }
    this.auth0Service.clearLocalStorage();
    this.router.navigate(['']);
    return false;
  }
}